module.exports = __webpack_public_path__ + "img/gift-steps.3cac504e.png";